import React from 'react';
import { ChevronRight } from 'lucide-react';
import { AuthSimulator } from './AuthSimulator';

export const ArchitectureShowcase: React.FC = () => {
  return (
    <section id="architecture" style={{ padding: '80px 20px 100px', backgroundColor: '#121212' }}>
      <div className="container">
        
        {/* Centered micro1 Intelligence Style Header */}
        <div style={{ textAlign: 'center', maxWidth: '780px', margin: '0 auto 64px' }}>
          <h2 
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: 'clamp(28px, 4vw, 36px)',
              fontWeight: 400,
              color: '#FFFFFF',
              letterSpacing: '-0.5px',
              margin: '0 0 16px'
            }}
          >
            draway Architecture
          </h2>
          <p 
            style={{
              fontFamily: "'Outfit', sans-serif",
              fontSize: '15px',
              lineHeight: 1.65,
              color: '#D7D7D7',
              maxWidth: '680px',
              margin: '0 auto'
            }}
          >
            We&apos;re building the infrastructure for securing software through WebAuthn passkeys, 
            real-world telephony fraud shields, and cryptographic session isolation.
          </p>
        </div>

        {/* 2-Column Showcase */}
        <div 
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '48px',
            alignItems: 'center',
            maxWidth: '1100px',
            margin: '0 auto'
          }}
          className="architecture-grid"
        >
          {/* Left Column: Product Capability & Description */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
            <div style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
              <span 
                style={{
                  fontFamily: "'Outfit', sans-serif",
                  fontSize: '22px',
                  fontWeight: 500,
                  color: '#FFFFFF',
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: '6px',
                  cursor: 'pointer'
                }}
              >
                State Machine
                <ChevronRight size={18} color="#6D7CFF" />
              </span>
            </div>

            <p 
              style={{
                fontFamily: "'Outfit', sans-serif",
                fontSize: '15px',
                lineHeight: 1.7,
                color: '#D7D7D7',
                margin: 0
              }}
            >
              An environment that strictly isolates unverified sessions in cryptographically signed 5-minute <code>mfaToken</code> envelopes, blocking any access to tenant databases or protected API routes until proof-of-possession is established.
            </p>

            {/* Architecture Metrics Grid */}
            <div 
              style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gap: '16px',
                marginTop: '16px',
                paddingTop: '20px',
                borderTop: '1px solid rgba(255, 255, 255, 0.08)'
              }}
            >
              <div>
                <div style={{ fontSize: '18px', fontWeight: 500, color: '#FFFFFF' }}>&lt; 15ms</div>
                <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>Edge JWKS</div>
              </div>
              <div>
                <div style={{ fontSize: '18px', fontWeight: 500, color: '#FFFFFF' }}>Argon2id</div>
                <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>Cryptographic Vault</div>
              </div>
              <div>
                <div style={{ fontSize: '18px', fontWeight: 500, color: '#FFFFFF' }}>FIDO2</div>
                <div style={{ fontSize: '12px', color: '#9CA3AF', marginTop: '2px' }}>Passkey Ready</div>
              </div>
            </div>
          </div>

          {/* Right Column: Floating Dark Slate Console */}
          <div style={{ position: 'relative' }}>
            <AuthSimulator />
          </div>
        </div>

      </div>
    </section>
  );
};

export default ArchitectureShowcase;
